module.exports = __webpack_public_path__ + "img/post-10.425f2806.jpg";